const module = { name: 'shared/global/promoCodeTout', exports: {} }; const exports = module.exports;



const Selectors = {
    LINK: '.promo-code-tout__link',
    TOUT: 'promo-code-tout',
}


const Classes = {
    ANIMATE: 'promo-code-tout--animate',
    HIDE: 'hide',
}
function init() {
    const tout = document.getElementById(Selectors.TOUT);
    if (!tout) {
        return;
    }
    const exposure = parseInt(tout.dataset.exposure);
    const random = Math.floor(Math.random() * 100);
    const showTout = random < exposure;
    if (!showTout) {
        return;
    }
    tout.classList.remove(Classes.HIDE);
    tout.querySelector(Selectors.LINK).addEventListener('click', function (e) {
        if (!this.classList.contains(Classes.ANIMATE)) {
            e.preventDefault();
            return this.classList.add(Classes.ANIMATE);
        }
    });
}
module.exports = {
    init
};
export default module.exports;